import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

export interface EventPriceGroupItem {
  id: number;
  label: string;
  is_active?: boolean;
  sort_order?: number;
}

/**
 * Active price groups for the add/edit-event Pris dropdown.
 */
export function event_price_groups(service: ComponentDataSourceService): DataSourceFunction {
  return {
    name: 'event_price_groups',
    description: 'Organisationens aktive prisgrupper til event-formularen',
    execute: (_params?: LoadDataParams): Observable<{ items: EventPriceGroupItem[]; totalCount: number }> => {
      return service.http
        .get<{ items?: EventPriceGroupItem[]; totalCount?: number }>(
          `${environment.apiUrl}/events/price-groups`,
          { params: { activeOnly: 'true' } }
        )
        .pipe(
          map((res) => ({
            items: (res?.items ?? []) as EventPriceGroupItem[],
            totalCount: res?.totalCount ?? (res?.items?.length ?? 0),
          })),
          catchError((error) => {
            console.error('[event_price_groups datasource] Error fetching price groups:', error);
            return of({ items: [], totalCount: 0 });
          })
        );
    },
  };
}
